<template>
  <div 
    ref="floatingRoot"
    class="whatsapp-icon-container-with whatsapp-container"
    :style="floatingStyle"
    :dir="isHebrew ? 'rtl' : 'ltr'">
    <a 
      href="https://wa.me/972526867915"
      target="_blank"
      rel="noopener noreferrer">
      <WhatsAppBadgeIcon :size="30" inverted class="whatsapp-chat-badge" />
      <span>{{ t('whatsappHereForYou') }}</span>
    </a>
  </div>
</template>



<script>
import WhatsAppBadgeIcon from "@/components/WhatsAppBadgeIcon.vue";
import { translationMixin } from "@/mixins/translationMixin";
import {
  getFloatingItemStyle,
  registerFloatingItem,
  unregisterFloatingItem,
  updateFloatingItem,
} from "@/services/floatingItems";

export default {
  name: "WhatsappChet",
  mixins: [translationMixin],
  components: {
    WhatsAppBadgeIcon,
  },
  data() {
    return {
      floatingId: "floating-whatsapp",
    };
  },
  computed: {
    floatingStyle() {
      return getFloatingItemStyle(this.floatingId);
    },
  },
  mounted() {
    registerFloatingItem({
      id: this.floatingId,
      priority: 40,
      anchor: "right",
      zIndex: 1001,
    });
    this.syncFloatingHeight();
  },
  beforeDestroy() {
    unregisterFloatingItem(this.floatingId);
  },
  methods: {
    syncFloatingHeight() {
      this.$nextTick(() => {
        const root = this.$refs.floatingRoot;
        if (!root) {
          return;
        }

        updateFloatingItem(this.floatingId, {
          visible: true,
          height: root.offsetHeight,
        });
      });
    },
  },
};
</script>

<style scoped>

.whatsapp-container {
  max-width: calc(100vw - 40px);
}

.whatsapp-container a {
  display: flex; /* Changed to flex to align icon and text */
  align-items: center; /* Align items vertically */
  background-color: #25d366;
  padding: 10px;
  border-radius: 10px; /* Slightly rounded corners */
  text-decoration: none; /* Remove underline from text */
}

/* The badge, not the old green PNG: a green mark on this green pill was
   invisible. The inverted badge brings its own white disc. */
.whatsapp-chat-badge {
  margin-inline-end: 10px; /* Add space between icon and text (LTR/RTL) */
}

.whatsapp-container span {
  color: white; /* Text color */
  font-size: 14px; /* Adjust as needed */
}

</style>
